// frontend/src/components/plot/charts/CustomTooltip.js
import React from 'react';

export default function CustomTooltip({ active, payload, label, localTimeEnabled }) {
  if (!active || !payload || payload.length === 0) return null;

  const timeStr = label
    ? (localTimeEnabled ? new Date(label).toLocaleString() : new Date(label).toUTCString())
    : '';

  return (
    <div style={{ background: '#ffffff', border: '1px solid #cbd5e1', padding: '12px', borderRadius: '8px', fontSize: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', maxWidth: '280px' }}>
      <div style={{ fontWeight: 600, marginBottom: '8px', color: '#1e293b', borderBottom: '1px solid #f1f5f9', paddingBottom: '4px' }}>
        {timeStr}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {payload.map((item, idx) => {
          const parts = String(item.name || '').split('\n');
          const metricLabel = parts[0] || item.dataKey;
          const deviceName = parts[1] || '';

          return (
            <div key={`tip-${idx}`} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: item.color, display: 'inline-block', marginTop: '3px', flexShrink: 0 }} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 600, color: '#0f172a' }}>
                  {metricLabel}: <strong>{item.value}</strong>
                </span>
                {deviceName && (
                  <span style={{ fontSize: '11px', color: '#64748b' }}>
                    {deviceName}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
